import React from 'react';
import './About.css'; // Importer le fichier CSS

function About() {
  return (
    // Section avec l'ID pour la navigation depuis la Navbar
    <section id="about" className="about-section">
      <div className="container"> {/* Conteneur pour centrer et limiter la largeur */}
        <h2 className="section-title">Notre Histoire, Votre Fromager</h2>

        <div className="about-content">
          {/* Partie Texte */}
          <div className="about-text">
            <p>
              Bienvenue Chez Paul, votre fromagerie artisanale nichée au cœur de L'Isle-Jourdain.
              Depuis [Année de création], nous mettons notre passion et notre savoir-faire au service
              de vos papilles en sélectionnant rigoureusement des fromages fermiers et locaux.
            </p>
            <p>
              Chaque fromage est choisi pour son caractère unique et affiné avec soin dans notre cave
              pour révéler toutes ses saveurs. Nous croyons en la qualité, la tradition et le lien
              direct avec les producteurs qui partagent nos valeurs.
            </p>
            <p>
              Venez nous rencontrer et laissez-vous guider pour découvrir des trésors gustatifs.
            </p>
          </div>

          {/* Partie Image */}
          <div className="about-image-container">
            {/* !! REMPLACEZ 'paul-le-fromager.jpg' par le nom de votre image !! */}
            {/* Notez le chemin qui commence par /images/ */}
            <img
              src="/images/logo.jpg"
              alt="Paul, l'artisan fromager de Chez Paul"
              className="about-image"
              loading="lazy" /* Améliore les performances */
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;